import { CIMSPage, DesignSubmittalStatus, Permission } from 'shared'
import {
  DesignSubmittal,
  useDesignSubmittalLogContext,
} from '../../../../DesignSubmittalLogContext'
import { useCreateDesignSubmittalCommentMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { SingleUser } from 'components/CIMSTable/common/hooks/useSingleUserColumn/components/SingleUser'

export function useExpandOptions(): ExpandOptions<DesignSubmittal> {
  const { refetch, edit } = useDesignSubmittalLogContext()
  const [createComment] = useCreateDesignSubmittalCommentMutation({
    ...DefaultMutationHookOptions,
  })
  return {
    render: ({
      id,
      fieldDesignChanges,
      dsToPayItemNoGeometries,
      comments,
      status,
      organization,
      submittedBy,
      submittedDate,
      deleted,
      customFields,
    }) => {
      return {
        additionalInfo: [
          {
            label: 'Submitted By',
            type: 'default',
            children: <SingleUser {...submittedBy} />,
          },
          {
            label: 'Submitted Date',
            type: 'date',
            date: submittedDate,
          },
          {
            label: 'Submitting Organization',
            type: 'default',
            children: organization.name,
          },
          {
            type: 'payItems',
            payItems: dsToPayItemNoGeometries.map(({ payItem }) => payItem),
            object: 'Design Submittal',
          },
          {
            label: 'Field Design Changes',
            type: 'deepLinks',
            showMore: { key: id },
            links: fieldDesignChanges.map(
              ({ id, formattedNumber, deleted }) => ({
                label: formattedNumber,
                page: CIMSPage.FDCTracker,
                deep: {
                  recordId: id,
                  deleted,
                },
              })
            ),
          },
        ],
        comments: {
          comments,
          permission: Permission.CommentOnDesignSubmittal,
          onSave: async (comment: string) => {
            await createComment({
              variables: {
                input: { submittalId: id, text: comment },
              },
            })
            await refetch()
          },
        },
        customFields: {
          recordInactive: deleted,
          alreadyDisabled:
            status === DesignSubmittalStatus.ReturnedToDesignBuilder
              ? {
                  why: 'invalid status',
                  statusName: DesignSubmittalStatus.ReturnedToDesignBuilder,
                }
              : false,
          customFields,
          booleanValueOptions: {
            onCheck: async (booleanInput) => {
              await edit({
                id,
                customFields: { booleanInputs: [booleanInput] },
              })
              refetch()
            },
          },
          listValueOptions: {
            onCheck: async (checkbox) => {
              await edit({
                id,
                customFields: { listInputs: { checkboxes: [checkbox] } },
              })
              refetch()
            },
          },
        },
      }
    },
  }
}
